import { ENTITIES, EntitiesAllProps } from 'lib/constants';

export const getEntityFromString = (entityString) => {
    if (!entityString) return console.warn('You forgot to pass params');
    let entity = ENTITIES[entityString];
    if (!entity) {
        const matchingEntity = EntitiesAllProps.filter((current) => {
            return current.values.includes(entityString);
        });
        if (matchingEntity?.[0]) entity = matchingEntity[0].entity;
    }

    if (!entity) return console.warn('This entity does not exist');
    return entity;
};
